import { memo } from "react";
import { Box } from "@mui/material";
import Loader from "../../UI/Loader";
import TextSlider from "../../UI/TextSlider";
import { makeStyles } from "@mui/styles";
import styles from "../styles";

const LOADING_MESSAGES = [
  "",
  "Please wait, its taking longer for this one",
  "Seems like the traffic is high today",
  "Generating your results",
  "Thanks for your patience, we are almost there",
];

function ChatBubble({ message, variant }) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  return (
    <Box
      key={message.message}
      alignItems="center"
      justifyContent="flex-end"
      display="flex"
      sx={{
        position: "relative",
        width: "100%",
        mt: 3,
        mb: 3,
      }}
    >
      <Box
        sx={{ border: variant === "error" && "1px solid #ff8f8f" }}
        className={classes.botMessage}
      >
        {variant === "loader" ? (
          <Box display="flex">
            <Loader />
            <TextSlider interval={7500} textArray={LOADING_MESSAGES} />
          </Box>
        ) : (
          message.message
        )}
      </Box>
    </Box>
  );
}

export default memo(
  ChatBubble,
  (prevProps, nextProps) =>
    prevProps.message === nextProps.message ||
    (prevProps.message.payload &&
      prevProps.message.payload === nextProps.message.payload)
);
